import { combineReducers } from 'redux';
import tree from './tree';
import customer from './customer';
import user from './user';
import users from './users';
import dashboard from './dashboard';
import auth from './auth';
import requestReducer from './request';

export default function createRootReducer() {
  const rootReducer = combineReducers({
    tree: tree,
    customer: customer,
    users: users,
    user: user,
    dashboard: dashboard,
    auth: auth,
    loading: requestReducer
  });
  return rootReducer;
}
